import type { T_Transaction } from '@/types/responses'


export const getTransactionType = (transaction: T_Transaction): any => {
  const { contractor, expense, receipt } = transaction

  const getName = () =>
    contractor.fullname ? `${contractor.login}, ${contractor.fullname}` : contractor.login

  if (expense && !contractor.system) return `Перевод ${getName()}`
  if (expense && contractor.system) return 'Покупка'
  if (receipt && !contractor.system) return `Перевод от ${getName()}`
  if (receipt && contractor.system) return 'Поступление'

  return null
}
